import type { ConceptAttribute, Graph } from "@lr-notitia/notitia-operator/schemas";
import { Ref, computed } from "vue";
import { useSymbolsStore } from "../symbols";

let symbolsStore: ReturnType<typeof useSymbolsStore>;
function init() {
	symbolsStore = useSymbolsStore();
}

export const conceptAttributes = (graph: Ref<Graph>) =>
	computed<ConceptAttribute[]>(() => {
		if (!symbolsStore) init();
		return (
			Object.values(graph.value.nodes).filter(
				(node) => node.type === "attribute" && node.layer === "concept"
			) as ConceptAttribute[]
		).sort((a, b) =>
			symbolsStore
				.term({ id: a.refersTo, terminology: a.terminology  })
				.toLocaleLowerCase()
				.localeCompare(
					symbolsStore.term({ id: b.refersTo, terminology: b.terminology  }).toLocaleLowerCase()
				)
		);
	});
export function conceptAttribute(domainId: Ref<string>, graph: Ref<Graph>) {
	return {
		byId: (id: string) => byId(id, graph),
	};
}

function byId(id: string, graph: Ref<Graph>): ConceptAttribute | undefined {
	let hit = graph.value.nodes[id];
	return hit && hit.type === "attribute" && hit.layer === "concept" ? (hit as ConceptAttribute) : undefined;
}
